import Model from 'flarum/common/Model';
export default class Team extends Model {
  name = Model.attribute('name');
  slug = Model.attribute('slug');
  logoPath = Model.attribute('logoPath');
  logoUrl = Model.attribute('logoUrl');
}
flarum.reg.add('huseyinfiliz-pickem', 'common/models/Team', Team);